module.exports = __webpack_public_path__ + "img/chongdian.a0889048.jpg";